export default "__VITE_ASSET__DAr$KUFH__"